// extracted by mini-css-extract-plugin
export default {"root":"QAReports_root__oOaEp"};